//  all Fetch API Types
import { config } from "./configuration/config";
import { getToken, handleLogout } from "./configuration/localstorage";
import axios from "axios";
import { path as RedirectPath } from "../../Utils/ScreenPath";
import LogOutfunction from "../../helper/LogOutfunction";
import Loader from "../../Common/Loader";
import { ErrorToast } from "../../Common/Toast";
export const axiosInstance = axios.create({
  baseURL: config.baseURL,
});


const getRequest = async (path, queryParams = {}) => {
  try {

    const queryString = new URLSearchParams(queryParams).toString();

    const url = queryString ? `${path}?${queryString}` : path;

    const params = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const res = await fetch(config.baseURL + url, params);
    let data = await res.text();

    // if (
    //   JSON.parse(data).message === "Invalid token" ||
    //   JSON.parse(data).message === "jwt expired"
    // ) {
    //   LogOutfunction();
    //   window.location.href = RedirectPath.Login;
    // }
    if (res.status !== 200) { ErrorToast(JSON.parse(data)?.message); }
    if (res.status === 401) {
      setTimeout(() => {
        handleLogout()
      }, 1000);
    }
    return { statusCode: res.status, data };
  } catch (e) {
    console.log(`error in get Request (${path}) :- `, e);
  }
};

const postRequest = async (path, body, extraHeaders = {}) => {
  try {
    const params = {
      method: "POST",
      headers: {
        ...typeof body === "string" && { "content-type": "application/json" },
        Authorization: "Bearer " + getToken(),
        ...extraHeaders,
      },
      body: body,
    };

    const res = await fetch(config.baseURL + path, params);
    let data = await res.text();

    if (res.status !== 200) { ErrorToast(JSON.parse(data)?.message); }
    if (res.status === 401) {
      setTimeout(() => {
        handleLogout()
      }, 1000);
    }
    return { statusCode: res.status, data };
  } catch (e) {
    console.log(`error in post Request (${path}) :- `, e);
    const data = null;
    return { statusCode: null, data };
  }
};

const DeleteRequest = async (path, queryParams = {}) => {

  const queryString = new URLSearchParams(queryParams).toString();

  const url = queryString ? `${path}?${queryString}` : path;

  try {
    const params = {
      method: "DELETE",
      headers: {
        "content-type": "text/plain;charset=UTF-8",
        Authorization: "Bearer " + getToken(),
      },
    };

    const res = await fetch(config.baseURL + url, params);
    let data = await res.text();

    if (res.status !== 200) { ErrorToast(JSON.parse(data)?.message); }
    if (res.status === 401) {
      setTimeout(() => {
        handleLogout()
      }, 1000);
    }
    return { statusCode: res.status, data };
  } catch (e) {
    console.log(`error in Delete Request (${path}) :- `, e);
  }
};

const putRequest = async (path, body) => {
  try {
    const params = {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + getToken(),
      },
      body: body,
    };

    const res = await fetch(config.baseURL + path, params);
    let data = await res.text();
    if (res.status !== 200) { ErrorToast(JSON.parse(data)?.message); }
    if (res.status === 401) {
      setTimeout(() => {
        handleLogout()
      }, 1000);
    }
    return { statusCode: res.status, data };
  } catch (e) {
    console.log(`error in PUT Request (${path}) :- `, e);
  }
};

const axiospostRequest = async (path, body, setProgress = () => { }) => {
  const res = await axiosInstance.post(path, body, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + getToken(),
    },
    onUploadProgress: (data) => {
      //Set the progress value to show the progress bar
      setProgress(Math?.round((100 * data?.loaded) / data?.total));
    },
  });
  return res.data;
};

const customRequest = async (uri, method, header, body) => {
  try {
    const params = {
      method: method,
      headers: header,
      body: body,
    };

    const res = await fetch(uri, params);

    let data = await res.text();

    if (res.status !== 200) { ErrorToast(JSON.parse(data)?.message); }
    if (res.status === 401) {
      setTimeout(() => {
        handleLogout()
      }, 1000);
    }
    return { statusCode: res.status, data };
  } catch (e) {
    console.log(`error in post Request (${uri}) :- `, e);
    const data = null;
    return { statusCode: null, data };
  }
};

export const ApiType = {
  getRequest,
  postRequest,
  DeleteRequest,
  putRequest,
  axiospostRequest,
  customRequest,
};
